export const errors = {
  RESOURCE_NOT_FOUND: "Resource not found",
  AUTH_FAILURE_INVALID_TOKEN: "Authentication Failure: Invalid token",
  AUTH_FAILURE_TOKEN_EXPIRED: "Authentication Failure: Token expired",
};
